import qs from 'qs';
import helpers from './helpers';

const profile = {
  /**
   * @param {object} data - Driver Profile
   */
  create(data) {
    return helpers.request('profile', helpers.requestOptions('POST', data));
  },
  options() {
    return helpers.request('profile', helpers.requestOptions('OPTIONS'));
  },
  search(query) {
    return helpers.request(`profiles?${qs.stringify(query)}`, helpers.requestOptions('GET'));
  },
};

export default profile;
